import { render } from "./TaskBox2.vue?vue&type=template&id=6908c2f9&scoped=true"
import script from "./TaskBox2.vue?vue&type=script&lang=js"
export * from "./TaskBox2.vue?vue&type=script&lang=js"

import "./TaskBox2.vue?vue&type=style&index=0&id=6908c2f9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6908c2f9"]])

export default __exports__